import {createAction, props} from '@ngrx/store';
import {DubletteNoticeDialogIntent} from '../states/dublette-notice-dialog.state';

export class DubletteNoticeDialogActions {
  private static readonly prefix = '[Dublette Notice Dialog] ';

  public static open = createAction(
    this.prefix + 'Open.',
    props<{
      intent: DubletteNoticeDialogIntent;
    }>(),
  );

  public static close = createAction(this.prefix + 'Close.');

  public static continueWithDublette = createAction(this.prefix + 'Continue with dublette.');
}
